import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import * as $ from "jquery";

import { routes } from "./app.router";
import { SafePipe } from "./app.safe.pipe";
import { AppComponent } from "./app.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ContactFormComponent } from "./contact/contact.component";
import { HttpClientModule } from "@angular/common/http";
import { ServicesService } from "./app.service";

import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { NavComponent } from "./nav/nav.component";
import { AboutComponent } from "./about/about.component";
import { SkillsComponent } from "./skills/skills.component";
import { PortfolioComponent } from "./portfolio/portfolio.component";
import { IntroductionComponent } from "./introduction/introduction.component";
import { MainPageComponent } from "./main-page/main-page.component";

//Private
//import { PrivateComponent } from "./private/private.component";
//import { StudyCasesComponent } from "./study-cases/study-cases.component";

//Portfolio pages
import { WorkTizoComponent } from "./work-tizo/work-tizo.component";
import { WorkHpComponent } from "./work-hp/work-hp.component";
import { WorkLonelyPlanetComponent } from "./work-lonely-planet/work-lonely-planet.component";
import { WorkWhyFiComponent } from "./work-why-fi/work-why-fi.component";
import { WorkSierraComponent } from "./work-sierra/work-sierra.component";
import { WorkDevexHomeComponent } from "./work-devex-home/work-devex-home.component";
import { WorkDevexRegistrationComponent } from "./work-devex-registration/work-devex-registration.component";
import { WorkDevexAppComponent } from "./work-devex-app/work-devex-app.component";

//Shared components
import { PortfolioIntroComponent } from "./shared/portfolio-intro/portfolio-intro.component";
import { PortfolioBrandingComponent } from "./shared/portfolio-branding/portfolio-branding.component";
import { PortfolioGridComponent } from "./shared/portfolio-grid/portfolio-grid.component";
import { PortfolioDescriptionComponent } from "./shared/portfolio-description/portfolio-description.component";
import { AlertMessages } from "./shared/alert-message/alert.component";

@NgModule({
  declarations: [
    //List of all component within module
    AppComponent,
    ContactFormComponent,
    SafePipe,
    HeaderComponent,
    NavComponent,
    FooterComponent,
    AboutComponent,
    SkillsComponent,
    PortfolioComponent,
    IntroductionComponent,
    MainPageComponent,
    PortfolioIntroComponent,
    PortfolioBrandingComponent,
    PortfolioGridComponent,
    PortfolioDescriptionComponent,
    WorkTizoComponent,
    WorkHpComponent,
    WorkLonelyPlanetComponent,
    WorkWhyFiComponent,
    WorkSierraComponent,
    WorkDevexHomeComponent,
    WorkDevexRegistrationComponent,
    WorkDevexAppComponent,
    AlertMessages,
  ],
  imports: [routes, BrowserModule, FormsModule, ReactiveFormsModule, HttpClientModule],
  //Loads required dependencies to launch pur app in the browser
  providers: [ServicesService],
  bootstrap: [
    // Indicates our root component
    AppComponent,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts